# frozen_string_literal: true

module Engine
  module Game
    module G18EU
    end
  end
end
